import type { Option } from '@branchjs/neo-components';
import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_COST_FILE_TEMPLATE_AD_PARTNER = 'UPDATE_COST_FILE_TEMPLATE_AD_PARTNER' as const;

export const updateCostFileTemplateAdPartner = (adPartner?: Option) => ({
  data: { adPartner },
  type: UPDATE_COST_FILE_TEMPLATE_AD_PARTNER,
});

export type UpdateCostFileTemplateAdPartnerAction = DataAction<
  typeof UPDATE_COST_FILE_TEMPLATE_AD_PARTNER,
  { adPartner?: Option }
>;
